import { TRAfastamento } from '@acme/core'
import dayjs from 'dayjs'
import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useAusenciasOutletContext } from 'pages/Ausencias.context'
import { SubmitHandler } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import { Afastamento, afastamento } from 'service/api'
import { toast } from 'sonner'
import { useStore } from 'store'
import FormDetalhesAfastamento from 'templates/ManutencaoDoPonto/Digitacao/forms/DetalhesAfastamento'
import IconeCadeado from './IconeCadeado'
import invalidateAusenciasQuery from './invalidateAusenciasQuery'

export default function EditarAfastamento() {
    const { id } = useParams()
    const { data, competencia } = useAusenciasOutletContext()
    const { mutateAsync } = afastamento.mutations.useUpdate()
    const empresa = useStore(state => state.company)
    const isEdicaoBloqueada = empresa?.competenciaAtual !== competencia
    const row = data?.find(a => a.id === 'afastamento_' + id) as TRAfastamento
    if (!row || !empresa) return null
    const periodo =
        row.dataInicio === row.dataFim
            ? row.dataInicio
            : `${row.dataInicio} a ${row.dataFim}`

    const handleSubmit: SubmitHandler<Afastamento> = data =>
        mutateAsync(
            {
                ...data,
                id: Number(String(row.id).split('_').at(-1)),
                dataInicial: dayjs(data.dataInicial).toDate(),
                dataFinal: dayjs(data.dataFinal).toDate(),
            },
            {
                onSuccess: async () => {
                    await invalidateAusenciasQuery()
                    toast.success('Afastamento editado com sucesso!')
                },
                onError: err => {
                    toast.error(err.message)
                },
            },
        )

    return (
        <Dialog.Root
            defaultValues={{
                ...row,
                dias: dayjs(row.dataFinal).diff(row.dataInicial, 'day') + 1,
            }}
            onSubmit={isEdicaoBloqueada ? undefined : handleSubmit}
            disableFields={isEdicaoBloqueada}
            open={hasPermission(['update', 'Afastamentos'])}
        >
            <Dialog.Title action="Editar afastamento">
                {row.funcionarioNome} · {periodo}{' '}
                {isEdicaoBloqueada && <IconeCadeado />}
            </Dialog.Title>
            <Dialog.Content>
                <FormDetalhesAfastamento />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
